// src/Components/route/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children, requiredPermissions }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  let permissions = [];
  try {
    const storedPermissions = localStorage.getItem('permissions');
    permissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  } catch (err) {
    console.error('Invalid permissions in localStorage:', err);
    permissions = [];
  }

  // Normalize to array
  const required = Array.isArray(requiredPermissions)
    ? requiredPermissions
    : [requiredPermissions];

  if (!isLoggedIn) return <Navigate to="/login" />;

  const hasAllPermissions = required.every(p => permissions.includes(p));
  if (required.length > 0 && !hasAllPermissions) {
    // console.warn("Missing required permissions:", required.filter(p => !permissions.includes(p)));
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default PrivateRoute;
